import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { destroy, formValueSelector, change as inputChange, submit } from "redux-form";
import countriesCode from "../../../../lib/utils/countriesCode";

import { CardNumberElement } from "@stripe/react-stripe-js";

import { emailValidation } from "lib/utils/donation-form-validation";

import { resetGivingForm } from "data/giving-form";

import { getUser } from "data/user";

import { getEnabledFeatures, getEntity } from "data/entity";

import { getCountries } from "data/assets";

import {
  getBillingType,
  getIsStripeSepaDebit,
  getPaymentInterval,
  getPaymentType,
} from "data/giving-form/billing";

import { getCampaign } from "data/parent-campaign";

import { getSpreedlyToken, triggerSpreedlyValidation } from "data/spreedly";

import { bindActionCreators } from "redux";

import {
  cancelStripePaymentIntent,
  createAbandonForm,
  createStripeCustomer,
  createStripeSubscription,
  fetchDonationToken,
  formSubmitted,
  getAccountStripeId,
  getAddingGift,
  getAllocations,
  getAllocationType,
  getAmountWithGiftAid,
  getBbmsPaymentKeys,
  getCentralizedGifts,
  getConfirming,
  getConnectedStripeAccountId,
  getDonationToken,
  getFeeAmount,
  getFormSubmitting,
  getIsGiftAid,
  getSelectedAllocations,
  getStripeClientSecretKey,
  getStripeElementsObject,
  getStripeObject,
  getStripePaymentId,
  getStripePaymentIntentId,
  getSubmitError,
  getTotalAmount,
  saveStripeDataPaymentMethod,
  selectAllocation,
  setAddingGift,
  setAmountWithGiftAid,
  setConfirming,
  setFeeAmount,
  setNewAmount,
  setStripeClientSecretKey,
  setStripePaymentIntentId,
  submitGivingForm,
  submittingForm,
  updateAllocationAmount,
} from "data/giving-form/allocation-selection";

import { commaNumber, stripCommas } from "lib/utils/numberFunctions";
import DisplayError from "../../../../lib/components/DisplayError";
import Funds from "../components/Funds";
import GiftAid from "../components/GiftAid";
import DonateForm from "../containers/DonateForm";

import {
  addBbmsEventListeners,
  fetchBbmsScript,
  handleBbmsPaymentProcessNextPage,
} from "../../../helpers/BbmsHelper";

import { createDropInObject } from "../../../helpers/BraintreeHelper";

import braintree from "braintree-web-drop-in";
import classNames from "classnames";
import { FormattedMessage, FormattedNumber } from "react-intl";
import CoverFee from "shared/components/cover-fee/CoverFee";
import { getClientToken } from "../../../api/giving-form-api/braintreeGivingFormApi";

class Form extends Component {
  isValidForCreateAbandonForm = true;
  bbmsPublicKey;
  bbmsAppId;
  bbmsAllValues;
  braintreeRef;
  state = {
    hasSubmitted: false,
    validating: false,
    formIsValid: false,
    addedCentralizedGifts: [],
    gatewayEnabledCentralizedGifts: true,
    loading: true,
    totalAmount: 0,
    totalAmountFunded: 0,
    braintreeDropin: undefined,
    hasBraintreeError: false,
    sepaDebitUrl: "",
  };

  constructor() {
    super();
    this.addEventListenerAbandonForm();
    this.braintreeRef = React.createRef();
  }

  async componentWillMount() {
    const { fetchDonationToken, isBraintreePayment, dispatch } = this.props;

    try {
      if (isBraintreePayment) {
        await this.getClientBraintreeToken();
      }
    } catch (error) {
      dispatch(
        formSubmitted(
          "There is error when try to generate braintree client token. Please contact support for more information.",
        ),
      );
      this.setState({
        hasBraintreeError: true,
      });
    }

    fetchDonationToken();
  }

  addEventListenerAbandonForm() {
    window.addEventListener("beforeunload", (ev) => {
      this.componentWillUnmount();
    });
  }

  cancelStripePaymentIntent() {
    const { entity, stripePaymentIntentId, dispatch } = this.props;

    if (stripePaymentIntentId) {
      cancelStripePaymentIntent(entity.get("id"), stripePaymentIntentId, dispatch);
    }
  }

  componentWillUnmount() {
    const {
      formSubmitting,
      first_name,
      last_name,
      email,
      entity,
      campaignId,
      user,
      isBbmsPayment,
    } = this.props;
    if (!user && this.isValidForCreateAbandonForm && !emailValidation(email)) {
      this.isValidForCreateAbandonForm = false;
      createAbandonForm(entity.get("id"), campaignId, first_name, last_name, email);
    }

    if (isBbmsPayment) {
      document.removeEventListener("checkoutComplete", this.bbmsCheckoutComplete);
    }

    // TODO: WHY are we cancelling payment intent??
    //
    // if (!formSubmitting) {
    //   this.cancelStripePaymentIntent()
    // }
  }

  updateAttrs = (attrs) => {
    const { isGiftAid, feeAmount } = this.props;
    const { braintreeNonce, braintreeType } = this.state;
    attrs.is_gift_aid = isGiftAid;
    attrs.fee_amount = feeAmount;
    attrs.braintree_nonce = braintreeNonce;
    attrs.braintree_payment_method_type = braintreeType;
  };

  customSubmit = (attrs, dispatch) => {
    const {
      campaignId,
      selectedAllocations,
      allocationType,
      spreedlyToken,
      formSubmitting,
      isStripePayment,
      isBbmsPayment,
      donationToken,
      isBraintreePayment,
      entity,
      isStripeSepaDebit,
      first_name,
      last_name,
      email,
      phone,
    } = this.props;
    const { totalAmount } = this.state;

    if (formSubmitting && !isStripePayment) {
      return;
    }

    dispatch(submittingForm());
    this.isValidForCreateAbandonForm = false;
    this.updateAttrs(attrs);

    const paymentType = isBbmsPayment ? "bbms" : null;
    const handleStripeSubmit = this.handleStripeSubmit;
    const entityId = entity.get("id");
    const { addedCentralizedGifts } = this.state;

    submitGivingForm({
      campaignId,
      dispatch,
      attrs,
      donationToken,
      selectedAllocations,
      allocationType,
      totalAmount,
      spreedlyToken,
      isBbmsPayment,
      paymentType,
      isStripePayment,
      isBraintreePayment,
      handleStripeSubmit,
      entityId,
      isStripeSepaDebit,
      addedCentralizedGifts,
    })
      .then()
      .catch((err) => {
        this.decreaseFee();
      });
  };

  formatValues = (values, dispatch) => {
    const {
      paymentType,
      paymentInterval,
      isStripePayment,
      isBbmsPayment,
      isStripeSepaDebit,
    } = this.props;

    const allValues = Object.assign({}, values);

    if (paymentInterval) {
      allValues.interval = paymentInterval;
    }

    if (paymentInterval === "monthly") {
      allValues.occurrences = parseFloat(values.occurrences) * 12;
    } else if (paymentInterval === "quarterly") {
      allValues.occurrences = parseFloat(values.occurrences) * 4;
    } else if (paymentInterval === "annually") {
      allValues.occurrences = parseFloat(values.occurrences) * 1;
    } else {
      // one time gift
      allValues.occurrences = null;
    }

    if (isBbmsPayment) {
      this.bbmsAllValues = allValues;
      return;
    }

    if (isStripeSepaDebit) {
      this.customSubmit(allValues, dispatch);
      return;
    }

    if (!isStripePayment || (isStripePayment && !allValues.interval)) {
      this.customSubmit(allValues, dispatch);
    } else {
      // is stripe subscriptionl
      this.handleStripeSubmit(allValues, dispatch);
    }
  };

  handleCloseModal = () => {
    const { onCloseModal } = this.props;

    onCloseModal();
  };

  sumCentralizedGiftsAmount = () => {
    const { addedCentralizedGifts } = this.state;
    return addedCentralizedGifts
      ? addedCentralizedGifts.reduce((t, i) => (t = t + i.amount), 0)
      : 0;
  };

  createStripeIntent = async () => {
    const { entity, dispatch, amount, feeAmount } = this.props;
    const stripeIntentData = await getAccountStripeId(
      parseFloat(stripCommas(amount)) + feeAmount + this.sumCentralizedGiftsAmount(),
      entity.get("id"),
      dispatch,
    );

    if (!stripeIntentData) {
      this.resetCentralizedGifts(true);
      dispatch(formSubmitted());
      return;
    }

    dispatch(setStripePaymentIntentId(stripeIntentData.stripe_payment_intent_id));
    dispatch(setStripeClientSecretKey(stripeIntentData.stripe_payment_client_secret));

    return stripeIntentData.stripe_payment_client_secret;
  };

  handleSubmit = async (e) => {
    const {
      isBbmsPayment,
      billingType,
      hasConfirmationStep,
      triggerSpreedlyValidation,
      isStripePayment,
      isBraintreePayment,
      isStripeSepaDebit,
      isRecurring,
      dispatch,
    } = this.props;

    e.preventDefault();

    if (isStripeSepaDebit && isRecurring) {
      this.submitForm();
      return;
    }

    if (isBbmsPayment) {
      this.submitForm();
      handleBbmsPaymentProcessNextPage.call(this);
      return;
    }

    this.setState({
      hasSubmitted: true,
      validating: true,
    });

    if (!hasConfirmationStep && typeof window.EventAnalyticsService != "undefined") {
      window.EventAnalyticsService.addEvent({
        name: "GIVING FORM - FINISH PAYMENT",
        giving_form_version: "React",
      });
    }

    if (isBraintreePayment) {
      this.submitBraintree();
      return;
    }

    if (billingType != "payroll deduction" && !isStripePayment && !isBraintreePayment) {
      triggerSpreedlyValidation(true);
    } else {
      if (isStripePayment) {
        if (!isStripeSepaDebit) {
          await this.createStripeIntent();
        }
      }

      this.submitForm();
    }
  };

  handleAddingGift = () => {
    const { setAddingGift } = this.props;

    setAddingGift(true);
  };

  handleConfirm = (e) => {
    const { setAddingGift, setConfirming } = this.props;

    setAddingGift(false);
    setConfirming(true);

    window &&
      window.SnapAnalytics &&
      window.SnapAnalytics.track({
        hitType: "event",
        eventCategory: "giving form",
        eventAction: "donationFormConfirmation",
      });

    if (typeof window.EventAnalyticsService != "undefined") {
      window.EventAnalyticsService.addEvent({
        name: "GIVING FORM - FINISH PAYMENT",
        giving_form_version: "React",
      });
    }

    if (
      parseFloat(this.props.amount) + parseFloat(this.state.totalAmountFunded) >
      parseFloat(this.props.totalAmount)
    ) {
      this.setState({
        totalAmountFunded: 0,
      });
    }
  };

  submitForm = () => {
    const { submit } = this.props;

    if (typeof window.EventAnalyticsService != "undefined") {
      window.EventAnalyticsService.addEvent({
        name: "GIVING FORM - DONATION SUBMISSION",
        giving_form_version: "React",
      });
    }

    submit("donation");
  };

  stopValidation = () => {
    this.setState({
      validating: false,
    });
    this.resetCentralizedGifts(true);
    this.props.setConfirming(false);
  };

  handlePreviousPage = (e) => {
    const { destroy, previousPage, resetGivingForm } = this.props;

    e.preventDefault();

    if (!window.PersistentCartService) {
      destroy("donation");
      resetGivingForm();
    }
    previousPage();
  };

  isFormValid = (isValid) => {
    this.setState({
      formIsValid: isValid,
    });
  };

  getClientBraintreeToken = async () => {
    const { entity, dispatch } = this.props;
    const response = await getClientToken(entity.get("id"));
    if (!response || (response && response.response && response.response.status != 200)) {
      dispatch(
        formSubmitted(
          "There is error when try to generate braintree client token. Please contact support for more information.",
        ),
      );
      this.setState({
        hasBraintreeError: true,
      });
      return;
    }

    this.createDropIn(
      response.client_token,
      response.merchant_id,
      response.google_pay_merchant_id,
    );
  };

  createDropIn = (client_token, merchant_id, google_pay_merchant_id) => {
    const { totalAmount, currencyCode, entity, billingType } = this.props;
    const amount = totalAmount.toString();
    const dropInObject = createDropInObject(
      billingType,
      amount,
      currencyCode,
      entity.get("name"),
      client_token,
      merchant_id,
      google_pay_merchant_id,
    );
    braintree
      .create(dropInObject)
      .then((dropinInstance) => {
        this.setState({
          braintreeDropin: dropinInstance,
        });
      })
      .catch((error) => {
        dispatch(
          formSubmitted(
            "There is error when try to create the braintree drop-in. Please contact support for more information.",
          ),
        );
        this.setState({
          hasBraintreeError: true,
        });
      });
  };

  async componentDidMount() {
    window &&
      window.SnapAnalytics &&
      window.SnapAnalytics.track({
        hitType: "event",
        eventCategory: "giving form",
        eventAction: "donationForm",
      });

    const { isBbmsPayment, totalAmount } = this.props;

    this.setState({
      totalAmount,
    });

    this.checkGatewayForAddingGift();
    if (isBbmsPayment) {
      this.handleBbmsPaymentProcess();
    } else {
      this.setState({
        loading: false,
      });
    }
  }

  handleBbmsPaymentProcess = () => {
    this.fetchBbmsFirstData();
    fetchBbmsScript();
    addBbmsEventListeners.call(this);
  };

  fetchBbmsFirstData = () => {
    const { entity, dispatch } = this.props;

    const bbmsPaymentKeys = getBbmsPaymentKeys(entity.get("id"), dispatch);
    bbmsPaymentKeys.then((data) => {
      if (!data) {
        this.setState({
          loading: false,
        });
        return;
      }

      this.bbmsPublicKey = data.bbms_public_key;
      this.bbmsAppId = data.bbms_app_id;
      this.setState({
        loading: false,
      });
    });
  };

  bbmsCheckoutComplete = (e) => {
    const { dispatch } = this.props;

    this.bbmsAllValues.bbms_transaction_token = e.detail.transactionToken;
    this.customSubmit(this.bbmsAllValues, dispatch);
  };

  checkGatewayForAddingGift = () => {
    const { selectedAllocations, centralizedGifts } = this.props;
    const gatewayId =
      selectedAllocations.count() > 0 && selectedAllocations.first().get("gateway_id");
    Array.isArray(centralizedGifts) &&
      centralizedGifts.forEach((centralizedGiftAllocation) => {
        if (gatewayId && centralizedGiftAllocation.get("gateway_id") !== gatewayId) {
          this.setState({
            gatewayEnabledCentralizedGifts: false,
          });
        }
      });
  };

  resetCentralizedGifts = (updateAllocations) => {
    const { addedCentralizedGifts, totalAmount } = this.state;
    const {
      selectedAllocations,
      selectAllocation,
      updateAllocationAmount,
      isAdditionalGiftEnabled,
    } = this.props;

    if (isAdditionalGiftEnabled) {
      if (updateAllocations) {
        for (let currentGiftIndex in addedCentralizedGifts) {
          const currentGift = addedCentralizedGifts[currentGiftIndex];
          if (currentGift) {
            const selectedAllocation = selectedAllocations.filter(
              (alloc) => alloc.toJS().id === currentGift.allocation.toJS().id,
            );

            const finalAllocationAmount =
              selectedAllocation.first().get("amount") - currentGift.amount;
            if (finalAllocationAmount == 0) {
              updateAllocationAmount(selectedAllocation.first(), finalAllocationAmount);
              selectAllocation(currentGift.allocation, false, totalAmount);
            } else {
              updateAllocationAmount(selectedAllocation.first(), finalAllocationAmount);
            }
          }
        }
      }

      this.setState({ addedCentralizedGifts: [] });
    }
  };

  handleCheckedFee = (isCoverFee, feeAmount) => {
    const { totalAmount } = this.state;
    const { setFeeAmount } = this.props;
    const totalAmountFloat = parseFloat(totalAmount);
    const feeAmountFloat = parseFloat(feeAmount);
    this.setState({
      totalAmount: isCoverFee
        ? totalAmountFloat + feeAmountFloat
        : totalAmountFloat - feeAmountFloat,
    });
    setFeeAmount(isCoverFee ? feeAmountFloat : 0);
  };

  decreaseFee = () => {
    const { feeAmount, dispatch } = this.props;
    const { totalAmount } = this.state;

    this.setState({
      totalAmount: totalAmount - feeAmount,
    });

    dispatch(setFeeAmount(0));
  };

  handleBackConfirming = () => {
    const { setConfirming, setAddingGift } = this.props;

    this.decreaseFee();

    setConfirming(false);
    setAddingGift(true);
    this.resetCentralizedGifts(true);
  };

  renderConfirmation() {
    const {
      entity,
      formSubmitting,
      selectedAllocations,
      currencySymbol,
      isEnabledGiftAid,
      isGiftAid,
      amountWithGiftAid,
      addingGift,
      isAdditionalGiftEnabled,
      setConfirming,
      setAddingGift,
    } = this.props;

    const currencyCode = entity.get("currency_code");
    const { formIsValid, totalAmount, totalAmountFunded } = this.state;
    const displayConfirmationStep =
      addingGift && isAdditionalGiftEnabled ? "none" : "inherit";
    const finalAmount = (
      parseFloat(stripCommas(totalAmount)) +
      parseFloat(stripCommas(this.sumCentralizedGiftsAmount()))
    ).toFixed(2);

    return (
      <section
        className="Modal__Content donate-modal primary-color-background"
        style={{ display: displayConfirmationStep }}>
        <div className="voting-modal-background">
          <button
            data-testid="t-giving-form--Form-modal-close-button"
            aria-label="Modal Close Button"
            className="modal-close-button"
            onClick={this.handleCloseModal}>
            <i className="fa fa-times fa-2x" />
          </button>
          <div className="p-md-b">
            <h2 className="voting-modal-header">
              {entity.get("donation_modal_header") ? (
                entity.get("donation_modal_header")
              ) : (
                <span>
                  <FormattedMessage id="giftInformation" /> &gt;{" "}
                  <FormattedMessage id="payment" /> &gt;
                  <span className="step-active">
                    {" "}
                    <FormattedMessage id="confirmation" />{" "}
                  </span>
                </span>
              )}
            </h2>
            <span className="white-font-color" />
          </div>
          <div className="voting-modal-body">
            <div className="text-center">
              <br />
              <h2>
                <span style={{ fontWeight: "normal", textTransform: "none" }}>
                  You are about to give a total of &nbsp;
                  <FormattedNumber
                    value={finalAmount}
                    style="currency"
                    currencyDisplay="symbol"
                    currency={currencyCode}
                  />
                  <br />
                  <br />
                </span>
                {selectedAllocations
                  .sort((allocationA, allocationB) => {
                    return allocationA.toJS().name > allocationB.toJS().name;
                  })
                  .map((allocation) => {
                    const allocationAsJS = allocation.toJS();
                    return (
                      <div
                        style={{
                          fontSize: "1.5rem",
                          fontWeight: "normal",
                          textAlign: "left",
                          minWidth: "300px",
                          maxWidth: "600px",
                          width: "60%",
                          display: "inline-block",
                        }}
                        key={allocationAsJS.id}>
                        <span style={{ float: "left", display: "inline-block" }}>
                          {allocationAsJS.name}
                        </span>
                        <span style={{ float: "right", display: "inline-block" }}>
                          <FormattedNumber
                            value={allocationAsJS.amount.toFixed(2)}
                            style="currency"
                            currencyDisplay="symbol"
                            currency={currencyCode}
                          />
                        </span>
                      </div>
                    );
                  })}
              </h2>
              <div
                style={{
                  fontSize: "1.5rem",
                  fontWeight: "normal",
                  minWidth: "300px",
                  maxWidth: "600px",
                  width: "60%",
                  display: "inline-block",
                }}
              />
              <br />
              <CoverFee
                currencyCode={currencyCode}
                totalAmount={totalAmount}
                currencySymbol={currencySymbol}
                handleCheckedFee={this.handleCheckedFee}
              />
              <br />
              <br />
              <br />
              <i
                className="donate-back-button primary-color-text pointer"
                onClick={this.handleBackConfirming}
                style={{ position: "relative", left: "initial" }}
              />
            </div>
            <br />
            <br />
          </div>
          {isEnabledGiftAid && isGiftAid && amountWithGiftAid > 0 && (
            <GiftAid
              currencyCode={currencyCode}
              amountWithGiftAid={amountWithGiftAid}
              classColor="white-font-color"
            />
          )}
          <div>
            <button
              data-testid="t-giving-form--Form-button-2"
              className="voting-modal-btn secondary-color-background"
              disabled={formIsValid}
              onClick={(e) => {
                this.handleSubmit(e);
              }}
              title="donation-button"
              type="submit">
              {formSubmitting ? (
                <i className="fa fa-2x fa-refresh fa-spin" />
              ) : (
                <FormattedMessage id="giveNow" />
              )}
            </button>
          </div>
        </div>
      </section>
    );
  }

  renderFunds() {
    const { formIsValid } = this.state;
    const { hasConfirmationStep, setAddingGift } = this.props;

    return (
      <Funds
        formIsValid={formIsValid}
        hasConfirmationStep={hasConfirmationStep}
        updateAllocationsAmountWithGifts={this.updateAllocationsAmountWithGifts}
        handleConfirm={this.handleConfirm}
        resetCentralizedGifts={this.resetCentralizedGifts}
        handleSubmit={this.handleSubmit}
        handleCloseModal={this.handleCloseModal}
        handleFundAdded={this.handleFundAdded}
        setAddingGift={setAddingGift}
      />
    );
  }

  updateAllocationsAmountWithGifts = () => {
    const { addedCentralizedGifts, totalAmount } = this.state;
    const {
      selectedAllocations,
      selectAllocation,
      updateAllocationAmount,
      entity,
      setStripeClientSecretKey,
      setAmountWithGiftAid,
      stripePaymentIntentId,
      dispatch,
      formSubmitted,
    } = this.props;

    dispatch(submittingForm());
    let addedAmount = 0;
    for (let currentGiftIndex in addedCentralizedGifts) {
      const currentGift = addedCentralizedGifts[currentGiftIndex];
      if (currentGift) {
        const selectedAllocation = selectedAllocations.filter(
          (alloc) => alloc.toJS().id === currentGift.allocation.toJS().id,
        );
        addedAmount += currentGift.amount;
        if (!selectedAllocation || selectedAllocation.size === 0) {
          selectAllocation(currentGift.allocation, true, currentGift.amount);
          updateAllocationAmount(currentGift.allocation, currentGift.amount);
        } else {
          updateAllocationAmount(
            selectedAllocation.first(),
            selectedAllocation.first().get("amount") + currentGift.amount,
          );
        }
      }
    }

    setAmountWithGiftAid(totalAmount + addedAmount + (totalAmount + addedAmount) * 0.25);

    this.handleConfirm();
    dispatch(formSubmitted());
  };

  handleFundAdded = (allocation, isAdded, amount) => {
    const { entity } = this.props;
    this.setState({
      totalAmountFunded: 0,
    });
    const { totalAmount } = this.state;
    if (isAdded) {
      this.addFund(allocation, amount);
      this.setState({
        totalAmountFunded: amount,
      });
    } else {
      this.removeFund(allocation);
    }
  };

  removeFund = (allocation) => {
    const { addedCentralizedGifts } = this.state;
    let currentAddedCentralizedGifts = Object.assign([], addedCentralizedGifts);

    currentAddedCentralizedGifts = currentAddedCentralizedGifts.filter(
      (gift) => gift.allocation.toJS().id !== allocation.toJS().id,
    );

    this.setState({ addedCentralizedGifts: currentAddedCentralizedGifts });
  };

  addFund = (allocation, amount) => {
    const { addedCentralizedGifts } = this.state;
    let currentAddedCentralizedGifts = Object.assign([], addedCentralizedGifts);

    let currentGift = currentAddedCentralizedGifts.filter(
      (gift) => gift.allocation.toJS().id === allocation.toJS().id,
    );

    if (currentGift && currentGift.length > 0) {
      currentGift[0].amount = amount;
    } else {
      currentAddedCentralizedGifts.push({
        allocation: allocation,
        amount: amount,
      });
    }

    this.setState({ addedCentralizedGifts: currentAddedCentralizedGifts });
  };

  renderStepLabel() {
    const { billingType } = this.props;

    if (billingType == "payroll deduction") {
      return (
        <span className="step_credit primary-color-text secondary-color-border-bottom-2px">
          <i className="fa fa-certificate fa-lg m-sm-r" />
          <FormattedMessage id="payrollDeduction" />
        </span>
      );
    }
    return (
      <span className="step_credit primary-color-text secondary-color-border-bottom-2px">
        <i className="fa fa-credit-card-alt fa-lg m-sm-r" />
        <FormattedMessage id="creditCard" />
      </span>
    );
  }

  updateStateFormSubmit = (cardNumberElement, dispatch) => {
    const { submittingForm } = this.props;
    if (!cardNumberElement) {
      dispatch(
        formSubmitted(
          "There is an error with the stripe card elements. Please contact support for more information.",
        ),
      );
      return;
    }

    cardNumberElement._invalid ? dispatch(formSubmitted()) : dispatch(submittingForm());
  };

  handleStripeSubmit = async (allValues, dispatch, donationIds = null) => {
    const {
      entity,
      stripeObject,
      stripeElementsObject,
      stripeClientSecretKey,
      billingType,
      user,
      email,
    } = this.props;

    if (!stripeObject || !stripeElementsObject) {
      dispatch(
        formSubmitted(
          "Stripe is not initialized. Please contact support for more information.",
        ),
      );
      this.decreaseFee();
      return;
    }

    this.updateStateFormSubmit(
      stripeElementsObject.getElement(CardNumberElement),
      dispatch,
    );

    const emailParam = user ? user.get("email") : email;
    if (billingType !== "recurring") {
      let result;
      if (allValues.succeeded === "succeeded") {
        result = allValues.result;
      } else {
        result = await stripeObject.confirmCardPayment(stripeClientSecretKey, {
          payment_method: {
            card: stripeElementsObject.getElement(CardNumberElement),
            billing_details: this.getBillingDetails(),
          },
        });
      }

      if (result.error) {
        this.resetCentralizedGifts(true);
        this.decreaseFee();
        dispatch(formSubmitted(result.error.message));
      } else {
        if (result.paymentIntent.status === "succeeded") {
          const payment_method_id = result.paymentIntent.payment_method;
          const currency_code = result.paymentIntent.currency.toUpperCase();
          const payment_intent_id = result.paymentIntent.id;
          saveStripeDataPaymentMethod(
            entity.get("id"),
            donationIds,
            payment_method_id,
            currency_code,
            payment_intent_id,
            dispatch,
          );
        }
      }
    } else {
      this.handleCreateStripeCustomer(emailParam, allValues, dispatch);
    }
  };

  submitBraintree = async (atters) => {
    const { dispatch } = this.props;
    const { braintreeDropin } = this.state;
    await braintreeDropin.requestPaymentMethod((err, payload) => {
      if (err) {
        dispatch(
          formSubmitted(
            "Something wrong with the payment details, please check and try again",
          ),
        );
        this.setState({
          hasBraintreeError: true,
        });
        return;
      }

      this.setState({
        braintreeNonce: payload.nonce,
        braintreeType: payload.type,
      });

      this.submitForm();
    });
  };

  handleCreateStripeCustomer = async (
    email,
    allValues,
    dispatch,
    paymentMethodId,
    skipCreatePaymentMethod = false,
  ) => {
    const { stripeObject, stripeElementsObject, entity, first_name, last_name } =
      this.props;

    const firstName =
      allValues && allValues.first_name ? allValues.first_name : first_name;
    const lastName = allValues && allValues.last_name ? allValues.last_name : last_name;
    const customer = await createStripeCustomer(
      email,
      firstName,
      lastName,
      entity.get("id"),
      dispatch,
    );
    if (!customer) {
      dispatch(
        formSubmitted(
          "Form is not submitted. Could not create Stripe customer, please contact support for more information.",
        ),
      );
      return;
    }

    if (skipCreatePaymentMethod) {
      this.handleCreateSubscription(allValues, dispatch, customer, paymentMethodId);

      return;
    }

    const paymentMethodResult = await stripeObject.createPaymentMethod({
      type: "card",
      card: stripeElementsObject.getElement(CardNumberElement),
      billing_details: this.getBillingDetails(),
    });

    if (paymentMethodResult.error) {
      dispatch(formSubmitted(paymentMethodResult.error.message));
    } else {
      this.handleCreateSubscription(
        allValues,
        dispatch,
        customer,
        paymentMethodResult.paymentMethod.id,
      );
    }
  };

  handleCreateSubscription = async (
    allValues,
    dispatch,
    stripeCustomer,
    paymentMethodId,
  ) => {
    const { entity, nextPage } = this.props;
    const { totalAmount } = this.state;
    const createStripeResult = await createStripeSubscription(
      entity.get("id"),
      stripeCustomer.customer.id,
      paymentMethodId,
      allValues.interval,
      allValues.occurrences,
      totalAmount,
      dispatch,
    );
    if (createStripeResult && createStripeResult.status === 200) {
      allValues.stripe_subscription_id =
        createStripeResult.data.subscription.subscription;
      allValues.stripe_payment_method_id = paymentMethodId;
      this.customSubmit(allValues, dispatch);
    }
  };

  getBillingDetails = () => {
    const {
      user,
      email,
      first_name,
      last_name,
      city,
      region,
      zip,
      country,
      address,
      address2,
    } = this.props;

    const emailParam = user ? user.get("email") : email;
    const countryCode = countriesCode.filter(
      (countryCode) => countryCode.name === country,
    );
    return {
      address: {
        city: city,
        country: countryCode ? countryCode[0].code : "",
        line1: address,
        line2: address2,
        postal_code: zip,
        state: region,
      },
      email: emailParam,
      name: `${first_name} ${last_name}`,
    };
  };

  render() {
    const {
      entity,
      countries,
      submitError,
      formSubmitting,
      confirming,
      currencySymbol,
      isEnabledGiftAid,
      isGiftAid,
      amountWithGiftAid,
      addingGift,
      isAdditionalGiftEnabled,
      centralizedGifts,
      currencyCode,
    } = this.props;

    const {
      formIsValid,
      gatewayEnabledCentralizedGifts,
      loading,
      totalAmount,
      braintreeDropin,
      donorCommentsEnabled,
      hasBraintreeError,
    } = this.state;
    const displayPaymentStep =
      (confirming && this.props.hasConfirmationStep) ||
      (addingGift && isAdditionalGiftEnabled)
        ? "none"
        : "inherit";

    if (loading) {
      return (
        <div key={"spinner"} className="m-p-t m-p-b text-center">
          <i className="fa fa-5x fa-refresh fa-spin" />
        </div>
      );
    }

    return (
      <div>
        <section
          className="Modal__Content donate-modal primary-color-background"
          style={{ display: displayPaymentStep }}>
          <div className="voting-modal-background">
            <button
              data-testid="t-giving-form--Form-modal-close-button"
              aria-label="Modal Close Button"
              className="modal-close-button"
              onClick={this.handleCloseModal}>
              <i className="fa fa-times fa-2x" />
            </button>
            <div className="p-md-b">
              <h2 className="voting-modal-header">
                {entity.get("donation_modal_header") ? (
                  entity.get("donation_modal_header")
                ) : (
                  <span>
                    <FormattedMessage id="giftInformation" /> &gt;
                    <span className="step-active">
                      {" "}
                      <FormattedMessage id="payment" />{" "}
                    </span>
                    {this.props.hasConfirmationStep ? (
                      <span>
                        {" "}
                        &gt; <FormattedMessage id="confirmation" />
                      </span>
                    ) : (
                      ""
                    )}
                  </span>
                )}
              </h2>
            </div>
            <div className="voting-modal-body">
              <div className="donating-steps">
                {this.renderStepLabel()}
                <i
                  className="donate-back-button primary-color-text pointer"
                  onClick={this.handlePreviousPage}
                />
              </div>
              <div className="text-center m-sm-t">
                {!formSubmitting && this.state.hasSubmitted && !this.state.validating && (
                  <span style={{ color: "red" }}>
                    Please check form below for missing required information
                  </span>
                )}
                <DisplayError error={submitError} />
              </div>

              <DonateForm
                donorCommentsEnabled={donorCommentsEnabled}
                hasBraintreeError={hasBraintreeError}
                braintreeDropin={braintreeDropin}
                submitForm={this.submitForm}
                stopValidation={this.stopValidation}
                customSubmit={this.customSubmit}
                handleCreateStripeCustomer={this.handleCreateStripeCustomer}
                onSubmit={this.formatValues}
                onGoingOrSplit={this.props.isRecurring || this.props.isOngoing}
                countries={countries}
                defaultCountry={entity.get("country")}
                isFormValid={this.isFormValid}
                createStripeIntent={this.createStripeIntent}
              />
            </div>
            <div>
              <div className="text-center m-sm-t">
                <h2 className="white-font-color">
                  <span style={{ fontWeight: "normal" }}>
                    <FormattedMessage id="giftAmount" />{" "}
                  </span>
                  <FormattedNumber
                    value={parseFloat(totalAmount).toFixed(2)}
                    style="currency"
                    currencyDisplay="symbol"
                    currency={currencyCode}
                  />
                </h2>
                {isEnabledGiftAid && isGiftAid && amountWithGiftAid > 0 && (
                  <GiftAid
                    currencyCode={currencyCode}
                    amountWithGiftAid={amountWithGiftAid}
                    classColor="white-font-color"
                  />
                )}
                {!formSubmitting && this.state.hasSubmitted && !this.state.validating && (
                  <span className="white-font-color">
                    <FormattedMessage id="missingFields" />
                  </span>
                )}
                <DisplayError className="white-font-color" error={submitError} />
              </div>

              {isAdditionalGiftEnabled &&
              centralizedGifts.size > 0 &&
              gatewayEnabledCentralizedGifts ? (
                <button
                  data-testid="t-giving-form--Form-submit"
                  className="voting-modal-btn secondary-color-background"
                  disabled={formIsValid}
                  onClick={this.handleAddingGift}
                  title="donation-button"
                  type="submit">
                  <FormattedMessage id="next" />
                </button>
              ) : this.props.hasConfirmationStep ? (
                <button
                  data-testid="t-giving-form--Form-submit"
                  className="voting-modal-btn secondary-color-background"
                  disabled={formIsValid}
                  onClick={this.handleConfirm}
                  title="donation-button"
                  type="submit">
                  {formSubmitting ? (
                    <i className="fa fa-2x fa-refresh fa-spin" />
                  ) : (
                    <FormattedMessage id="next" />
                  )}
                </button>
              ) : (
                <button
                  data-testid="t-giving-form--Form-submit"
                  className="voting-modal-btn secondary-color-background"
                  disabled={formIsValid}
                  onClick={this.handleSubmit}
                  title="donation-button"
                  type="submit">
                  {formSubmitting ? (
                    <i className="fa fa-2x fa-refresh fa-spin" />
                  ) : (
                    <FormattedMessage id="giveNow" />
                  )}
                </button>
              )}
            </div>
          </div>
        </section>
        {confirming && this.props.hasConfirmationStep ? this.renderConfirmation() : ""}
        {addingGift && isAdditionalGiftEnabled && gatewayEnabledCentralizedGifts
          ? this.renderFunds()
          : ""}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const user = getUser(state);
  const currentEntity = getEntity(state);
  let first_name, last_name, month, year;

  first_name = user
    ? user.get("first_name") || ""
    : formValueSelector("donation")(state, "first_name");
  last_name = user
    ? user.get("last_name") || ""
    : formValueSelector("donation")(state, "last_name");

  const currencyCode = currentEntity.get("currency_code");

  return {
    user,
    first_name,
    last_name,
    month,
    year,
    email: formValueSelector("donation")(state, "email"),
    address: formValueSelector("donation")(state, "address.address1"),
    address2: formValueSelector("donation")(state, "address.address2"),
    city: formValueSelector("donation")(state, "address.city"),
    region: formValueSelector("donation")(state, "address.region"),
    zip: formValueSelector("donation")(state, "address.zip"),
    country: formValueSelector("donation")(state, "address.country"),
    cell_phone: formValueSelector("donation")(state, "address.cell_phone"),
    amount: formValueSelector("donation")(state, "amount"),
    entity: currentEntity,
    currencySymbol: currentEntity.get("currency_symbol"),
    billingType: getBillingType(state),
    countries: getCountries(state),
    campaignId: getCampaign(state)("giving_form").get("id"),
    totalAmount: getTotalAmount(state),
    formSubmitting: getFormSubmitting(state),
    submitError: getSubmitError(state),
    selectedAllocations: getSelectedAllocations(state),
    paymentType: getPaymentType(state),
    paymentInterval: getPaymentInterval(state),
    allocationType: getAllocationType(state),
    spreedlyToken: getSpreedlyToken(state),
    confirming: getConfirming(state),
    addingGift: getAddingGift(state),
    stripePaymentId: getStripePaymentId(state),
    isStripePayment: getEnabledFeatures(state).includes("stripe"),
    donorCommentsEnabled: getEnabledFeatures(state).includes("donation_wall_comments"),
    connectedStripeAccountId: getConnectedStripeAccountId(state),
    stripeClientSecretKey: getStripeClientSecretKey(state),
    donationToken: getDonationToken(state),
    stripeObject: getStripeObject(state),
    stripeElementsObject: getStripeElementsObject(state),
    isGiftAid: getIsGiftAid(state),
    isEnabledGiftAid: getEnabledFeatures(state).includes("gift_aid"),
    amountWithGiftAid: getAmountWithGiftAid(state),
    feeAmount: getFeeAmount(state),
    isAdditionalGiftEnabled: getEnabledFeatures(state).includes(
      "additional_centralized_gift",
    ),
    allocations: getAllocations(state),
    centralizedGifts: getCentralizedGifts(state),
    isBbmsPayment: getEnabledFeatures(state).includes("bbms_payment"),
    stripePaymentIntentId: getStripePaymentIntentId(state),
    isBraintreePayment: getEnabledFeatures(state).includes("braintree_payment"),
    currencyCode: currencyCode,
    isStripeSepaDebit: getIsStripeSepaDebit(state),
  };
};

const mapActionCreators = (dispatch) => {
  return {
    dispatch,
    ...bindActionCreators(
      {
        submit,
        destroy,
        formSubmitted,
        triggerSpreedlyValidation,
        resetGivingForm,
        fetchDonationToken,
        setConfirming,
        setAddingGift,
        submittingForm,
        updateAllocationAmount,
        selectAllocation,
        setStripeClientSecretKey,
        setAmountWithGiftAid,
        setStripePaymentIntentId,
        saveStripeDataPaymentMethod,
        setFeeAmount,
      },
      dispatch,
    ),
  };
};

export default connect(mapStateToProps, mapActionCreators)(Form);
